/**
 * LP testimonials behavior (sections/medispa-lp-testimonials.liquid):
 * click-to-play/pause on video testimonial cards (desktop grid and mobile
 * slider), the text-testimonials carousel, and the mobile video carousel.
 * Loaded by deferred-scripts.liquid (marker: data-medispa-lp-testimonials).
 */
import { medispaCarousels, onDomReady, whenSwiperReady } from '@/components/utils/medispa-lp';

function bindVideoToggles(root: HTMLElement): void {
  root.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const gridItem = event.target.closest('.video_testimonial__grid-video');
    if (!gridItem || !root.contains(gridItem)) return;

    const video = gridItem.querySelector('video');
    if (!video) return;

    if (video.paused) {
      video.play();
      gridItem.classList.remove('paused');
    } else {
      video.pause();
      gridItem.classList.add('paused');
    }
  });
}

function initCarousels(root: HTMLElement): void {
  const carousels = medispaCarousels();

  const testimonialsSlider = root.querySelector<HTMLElement>('.testimonials-wrapper.swiper');

  if (testimonialsSlider) {
    carousels['testimonials'] = new window.Swiper(testimonialsSlider, {
      slidesPerView: 1,
      centeredSlides: true,
      pagination: {
        el: testimonialsSlider.querySelector<HTMLElement>('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: testimonialsSlider.querySelector<HTMLElement>('.swiper-button-next'),
        prevEl: testimonialsSlider.querySelector<HTMLElement>('.swiper-button-prev'),
      },
    });
  }

  const mobileSlider = root.querySelector<HTMLElement>('.mobile-video_testimonials-slider');

  if (mobileSlider) {
    carousels['mobile_video_testimonials'] = new window.Swiper(mobileSlider, {
      slidesPerView: 1.25,
      centeredSlides: true,
      spaceBetween: 16,
      pagination: {
        el: mobileSlider.querySelector<HTMLElement>('.swiper-pagination'),
        clickable: true,
      },
    });
  }
}

onDomReady(() => {
  document.querySelectorAll<HTMLElement>('[data-medispa-lp-testimonials]').forEach((root) => {
    bindVideoToggles(root);
    whenSwiperReady(() => initCarousels(root));
  });
});
